import React from 'react';

interface AutocompleteFormatGefahrgutklasseUnnrProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatGefahrgutklasseUnnr = ({
  suchvorschlag,
}: AutocompleteFormatGefahrgutklasseUnnrProps) => {
  return (
    suchvorschlag && (
      <span>
        {suchvorschlag[`unnr`]} - {suchvorschlag[`version`]} -{' '}
        {suchvorschlag[`bezeichnung`]} - {suchvorschlag['verpackungscode']} -{' '}
        {suchvorschlag['klassifizierung']} - {suchvorschlag['klasse']}
      </span>
    )
  );
};
